import PointsHistorySimpleView from './PointsHistorySimpleView'

export default PointsHistorySimpleView
